(function () {
  'use strict';
  function init(root) {
    if (root.c04ArrivalCleanup) root.c04ArrivalCleanup();
    var canvas = root.querySelector('canvas'), ctx = canvas.getContext('2d', {alpha: false});
    if (!ctx) return;
    var stage = root.querySelector('.c04-arrival__stage');
    var view = root.querySelector('.c04-arrival__viewport');
    var copy = root.querySelector('.c04-arrival__copy');
    var reveal = root.querySelector('.c04-arrival__reveal');
    var cue = root.querySelector('.c04-scroll-link');
    var motion = matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = matchMedia('(max-width: 749px)');
    var urls = JSON.parse(root.querySelector(mobile.matches ? '[data-c04-mobile-frames]' : '[data-c04-frames]').textContent);
    var controller = new AbortController();
    var blobs = [], fetched = new Set(), failed = new Set(), decoding = new Set(), cache = new Map();
    // A small permanent backbone covers the entire move; nearby detail frames
    // fill in between it without making reverse scrolling decode everything again.
    var anchors = [], anchorSet = new Set();
    for (var n = 0; n < urls.length; n += 5) { anchors.push(n); anchorSet.add(n); }
    if (!anchorSet.has(urls.length-1)) { anchors.push(urls.length-1); anchorSet.add(urls.length-1); }
    var network = 0, frame = 0, disposed = false, active = true;
    var target = 0, current = 0, lastTime = 0, drawn = -1, wanted = 0, travel = 1;
    var width = 0, height = 0;
    canvas.hidden = true;
    copy.style.opacity = ''; reveal.style.opacity = ''; reveal.style.visibility = ''; cue.style.opacity = '';
    function clamp(v) { return Math.max(0, Math.min(1, v)); }
    function close(image) { if (image && image.close) image.close(); }
    function trim() {
      // Keep a small decoded window, not 101 full-resolution surfaces on a phone.
      while (cache.size > anchorSet.size + 10) {
        var victim = -1, distance = -1;
        cache.forEach(function (_, index) {
          if (anchorSet.has(index) || index === drawn || index === wanted) return;
          var d = Math.abs(index-wanted);
          if (d > distance) { distance = d; victim = index; }
        });
        if (victim < 0) break;
        close(cache.get(victim)); cache.delete(victim);
      }
    }
    async function decode(index) {
      if (!blobs[index] || cache.has(index) || decoding.has(index) || decoding.size >= 2) return;
      decoding.add(index);
      try {
        var image;
        if (window.createImageBitmap) {
          try { image = await createImageBitmap(blobs[index]); } catch (_) { /* Safari fallback below. */ }
        }
        if (!image) {
          var objectUrl = URL.createObjectURL(blobs[index]);
          try { image = new Image(); image.src = objectUrl; await image.decode(); }
          finally { URL.revokeObjectURL(objectUrl); }
        }
        if (disposed) { close(image); return; }
        cache.set(index, image); trim();
      } catch (_) { failed.add(index); }
      finally { decoding.delete(index); if (!disposed) { pump(); wake(); } }
    }
    function priority() {
      var order = [wanted];
      // Spread the first downloads across the motion before fetching all 101.
      // Endpoints also cover an immediate jump to the reveal or back to the top.
      order.push(0, urls.length-1);
      anchors.slice().sort(function (a,b) { return Math.abs(a-wanted)-Math.abs(b-wanted); })
        .forEach(function (i) { order.push(i); });
      var direction = target >= current ? 1 : -1;
      for (var step = 1; step <= 6; step++) order.push(wanted+step*direction, wanted-step*direction);
      return Array.from(new Set(order.filter(function (i) { return i >= 0 && i < urls.length; })));
    }
    function pump() {
      if (disposed || motion.matches || !active) return;
      var order = priority();
      // Decode requested detail first, then retain the low-density backbone.
      var decodeOrder = [wanted];
      for (var d = 1; d <= 3; d++) decodeOrder.push(wanted+d, wanted-d);
      decodeOrder.concat(anchors).forEach(function (i) { if (!failed.has(i)) decode(i); });
      // Only fetch local detail after all anchor requests have been scheduled.
      // Remaining details warm in the background; concurrency stays bounded.
      for (var i = 0; i < urls.length; i++) order.push(i);
      order.forEach(function (index) {
        if (network >= 6 || fetched.has(index)) return;
        fetched.add(index); network++;
        fetch(urls[index], {signal: controller.signal, cache: 'force-cache', priority: index === wanted || anchorSet.has(index) ? 'high' : 'low'})
          .then(function (response) { if (!response.ok) throw new Error('Frame unavailable'); return response.blob(); })
          .then(function (blob) { if (!disposed) blobs[index] = blob; })
          .catch(function () { if (!disposed) failed.add(index); })
          .finally(function () { network--; if (!disposed) { pump(); wake(); } });
      });
    }
    function closestReady(index) {
      var closest = -1, distance = Infinity;
      cache.forEach(function (_, candidate) {
        // Never show a later scene ahead of the scroll (or an earlier one
        // when reversing) merely because that download completed first.
        if (travel > 0 ? candidate > index : candidate < index) return;
        var delta = Math.abs(candidate-index);
        if (delta < distance) { distance = delta; closest = candidate; }
      });
      return closest;
    }
    function draw(index) {
      var image = cache.get(index);
      if (!image) return false; // Keep the poster until the first decoded image is ready.
      if (drawn !== index || canvas.hidden) {
        var iw = image.width, ih = image.height;
        var scale = Math.max(width/iw, height/ih);
        ctx.drawImage(image, (width-iw*scale)/2, (height-ih*scale)/2, iw*scale, ih*scale);
        drawn = index;
        canvas.hidden = false; // Reveal only after a decoded frame has been painted.
      }
      return true;
    }
    function tick(time) {
      frame = 0;
      if (disposed || !active || motion.matches) return;
      var dt = Math.min(64, lastTime ? time-lastTime : 16); lastTime = time;
      current += (target-current)*(1-Math.exp(-dt/65));
      if (Math.abs(target-current) < .0005) current = target;
      wanted = Math.round(current*(urls.length-1));
      var ready = cache.has(wanted) ? wanted : closestReady(wanted);
      if (ready >= 0 && draw(ready)) {
        // Text follows the actual painted scene, not a frame still in flight.
        var shown = ready / Math.max(1, urls.length-1);
        copy.style.opacity = 1-clamp(shown/.23);
        cue.style.opacity = 1-clamp(shown/.15);
        var end = clamp((shown-.73)/.22);
        reveal.style.opacity = end; reveal.style.visibility = end > 0 ? 'visible' : 'hidden';
      }
      pump();
      if (current !== target) frame = requestAnimationFrame(tick);
    }
    function wake() {
      if (!disposed && !frame && active && !motion.matches) frame = requestAnimationFrame(tick);
    }
    function schedule() {
      if (disposed) return;
      var next = clamp(-root.getBoundingClientRect().top/Math.max(1,root.offsetHeight-stage.offsetHeight));
      if (next !== target) travel = next > target ? 1 : -1;
      target = next;
      wake();
    }
    function measure() {
      var w = view.clientWidth, h = view.clientHeight;
      // The canvas gains no detail by rasterizing beyond the source frames.
      var sourceWidth = mobile.matches ? 540 : 1120;
      var sourceHeight = mobile.matches ? 960 : 630;
      var ratio = Math.min(devicePixelRatio || 1, 2, Math.max(sourceWidth/w, sourceHeight/h));
      if (width !== w || height !== h || canvas.width !== Math.round(w*ratio)) {
        width = w; height = h;
        var previous = drawn;
        canvas.width = Math.round(w*ratio); canvas.height = Math.round(h*ratio);
        ctx.setTransform(ratio,0,0,ratio,0,0); drawn = -1;
        // Resize and repaint in one task, so Safari never displays a cleared canvas.
        if (previous < 0 || !draw(previous)) canvas.hidden = true;
      }
      schedule();
    }
    function restart() { init(root); }
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',measure,{passive:true});
    window.addEventListener('pageshow',measure);
    motion.addEventListener('change',restart); mobile.addEventListener('change',restart);
    var observer = new IntersectionObserver(function (entries) {
      active = entries[0].isIntersecting; lastTime = 0;
      if (active) { schedule(); pump(); }
    }); observer.observe(root);
    root.c04ArrivalCleanup = function () {
      disposed = true; controller.abort(); cancelAnimationFrame(frame); observer.disconnect();
      window.removeEventListener('scroll',schedule); window.removeEventListener('resize',measure); window.removeEventListener('pageshow',measure);
      motion.removeEventListener('change',restart); mobile.removeEventListener('change',restart);
      cache.forEach(close); cache.clear(); blobs.length = 0;
    };
    measure();
    // A restored scroll position must start at its own frame, not replay from zero.
    current = target; wanted = Math.round(current*(urls.length-1));
    pump();
  }
  function all(scope) { (scope || document).querySelectorAll('[data-c04-arrival]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { all(); }); else all();
  document.addEventListener('shopify:section:load',function (event) { all(event.target); });
  document.addEventListener('shopify:section:unload',function (event) {
    event.target.querySelectorAll('[data-c04-arrival]').forEach(function (root) { if (root.c04ArrivalCleanup) root.c04ArrivalCleanup(); });
  });
})();
